class StorageService {
  private storage: Storage;

  constructor(storage: Storage) {
    this.storage = storage;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setItem(key: string, value: any) {
    // Guard: localStorage.setItem(key, null) silently stores the string "null"
    // which is truthy and corrupts token reads. Skip the write instead.
    if (value === null || value === undefined) return;
    this.storage.setItem(key, value);
  }

  getItem(key: string) {
    const storedItem = this.storage.getItem(key);
    return storedItem ? storedItem : null;
  }

  removeItem(key: string) {
    this.storage.removeItem(key);
  }
}

export const storageService = new StorageService(localStorage);
